import { useLocation } from 'react-router-dom'
import CenterInfoBox from '../../components/admin/CenterInfoBox'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'

const CentersInfo = () => {
  const { state } = useLocation()

  return (
    <AdminLayout>
      <AdminContentLayout>
        <CenterInfoBox centerData={state} />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default CentersInfo
